import React from 'react';
import {
	Paper,
	Grid,
	Typography
} from '@mui/material';
import useMdUpScreen from '../hooks/useMdUpScreen';
import { useThemeCustomStyles, useThemeStatics } from '../hooks/useThemeConfig';

const Text = ({ children, sx }) => {
	return (<Typography sx={sx}>
    	{children}
    </Typography>);
};

export default function Footer() {
  const mdUpScreen = useMdUpScreen();
  const staticConfig = useThemeStatics();
  const styles = useThemeCustomStyles();
  const baseSx = styles.Footer.container;
  const dynamicSx =  styles.Footer.dynamicContainer(mdUpScreen);
  const itemSx = styles.Footer.gridItem;
	const { footerTexts: { column1, column2 } } = staticConfig;
  return (
    <Paper square elevation={12} sx={{ ...baseSx, ...dynamicSx }} >
		<Grid container >
			<Grid item sx={itemSx} xs={12} md={3} >
				{column1.map((text,i) => (<Text key={"footerItem"+i} sx={styles.Footer.item} >{text}</Text>))}
			</Grid>
			<Grid item sx={itemSx} xs={12} md={3} >
				{column2.map((text,i) => (<Text key={"footerItem"+i} sx={styles.Footer.item} >{text}</Text>))}
			</Grid>
		</Grid>
    </Paper>
  );
}